<template>
    <footer class="d-flex justify-content-between">
        <!-- <div>
            <a href="https://stronghold.thetanuts.finance/">
                <img
                    src="/images/landing-page/logo-thetanuts-2.svg"
                    alt="logo theta nuts footer"
                />
            </a>
        </div> -->
        <div
            class="d-flex footer-links__container"
            :class="{ 'green-hover': isGreenHover }"
        >
            <div class="flex-shrink-0 flex-grow-1">
                <h5>ThetaNuts Finance</h5>
                <div class="d-flex flex-column gap-2">
                    <!-- <a v-show="!hideThetanutsBasic" href="https://stronghold.thetanuts.finance/">
                        <span
                            class="gradient-text gradient-text--animated fw-bold"
                        >
                            THETANUTS STRONGHOLD
                        </span>
                    </a> -->
                    <router-link v-show="!hideThetanutsStronghold"  :to="{ name: 'vault' }">
                        <span
                            class="gradient-text gradient-text--animated fw-bold"
                        >
                            THETANUTS BASIC
                        </span>
                    </router-link>
                    <!-- <router-link :to="{ name: 'disclaimer' }" target="_blank">
                        Disclaimer
                    </router-link> -->
                    <!-- <router-link
                        :to="{ name: 'termscondition' }"
                        target="_blank"
                    >
                        Terms &amp; Conditions
                    </router-link> -->
                    <!-- <router-link
                        :to="{ name: 'privacypolicy' }"
                        target="_blank"
                    >
                        Privacy Policy
                    </router-link> -->
                </div>
            </div>
            <div
                class="flex-shrink-1 flex-grow-1"
                :class="{ 'green-hover': isGreenHover }"
            >
                <a target="blank" href="https://docs.thetanuts.finance/">
                    <h5>
                        DOCS
                    </h5>
                </a>
                <div class="d-flex flex-column gap-2">
                    <!-- <a target="blank" href="https://github.com/Theta-Nuts"
                        >GitHub</a
                    >
                    <a
                        target="blank"
                        href="https://thetanuts.gitbook.io/thetanuts/"
                        >Gitbook</a
                    >
                    <router-link :to="{ name: 'termscondition' }">
                        <a>Term Of Use</a>
                    </router-link> -->
                </div>
            </div>
            <div
                class="flex-shrink-1 flex-grow-1"
                :class="{ 'green-hover': isGreenHover }"
            >
                <h5>Community</h5>
                <div class="d-flex flex-column gap-2">
                    <a target="blank" href="https://twitter.com/ThetanutsFi"
                        >Twitter</a
                    >
                    <a
                        target="blank"
                        href="https://thetanutsfinance.medium.com/"
                        >Medium</a
                    >
                    <a target="blank" href="https://dsc.gg/thetanuts"
                        >Discord</a
                    >
                    <a target="blank" href="https://thetanuts.substack.com"
                        >Substack</a
                    >
                    <!-- <a href="#!">Telegram</a> -->
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    props: {
        hoverColor: {
            type: String,
            default: "default"
        },
        hideThetanutsBasic: {
            type: Boolean,
            default: false
        },
        hideThetanutsStronghold: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {};
    },
    computed: {
        isGreenHover() {
            return this.hoverColor === "green";
        }
    }
};
</script>

<style lang="scss" scoped>
footer {
    background: #172120;
    padding: 50px 16px;
    flex-direction: column;
    gap: 30px;

    @media only screen and (min-width: 768px) {
        padding: 50px;
        flex-direction: row;
    }

    @media only screen and (min-width: 1440px) {
        padding: 100px 150px;
        padding-left: 10vw;
        // padding-right: 8.89vw;
    }

    > div:nth-child(2) {
        flex-basis: 60%;
        justify-content: flex-end;

        @media only screen and (min-width: 768px) {
            flex-basis: 50%;
            gap: 25px;
            padding-right: 20px;
        }

        @media only screen and (min-width: 1440px) {
            flex-basis: 50%;
            gap: 80px;
        }
    }

    img {
        width: 180px;
        transition: all ease 0.3s;

        @media only screen and (min-width: 768px) {
            width: 263px;
        }

        &:hover {
            filter: drop-shadow(0px 0px 15px #1ae899);
        }
    }

    h5 {
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 700;
        line-height: 21px;
        letter-spacing: 0px;
        text-align: left;
        color: #fff;
        text-transform: uppercase;

        @media only screen and (min-width: 1440px) {
            font-size: 18px;
            line-height: 28px;
        }

        @media only screen and (min-width: 1920px) {
            font-size: 24px;
            line-height: 38px;
        }
    }

    a {
        font-family: Inter;

        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: left;

        @media only screen and (min-width: 1440px) {
            font-size: 18px;
            line-height: 40px;
        }

        @media only screen and (min-width: 1920px) {
            font-size: 15px;
            line-height: 35px;
        }

        text-transform: uppercase;

        h5 {
            &:hover {
                opacity: 0.8;
            }
        }
    }

    .footer-links__container {
        a {
            text-decoration: none;
            color: #fff;

            &:hover {
                opacity: 0.8;
            }
        }
    }

    .green-hover {
        a {
            h5:hover,
            &:hover {
                color: #4ec575;
            }
        }
    }
}
.gradient-text {
    background-image: linear-gradient(
        95.12deg,
        #1cc8c1 0%,
        #05feb1 0.01%,
        #d9ef46 28.64%,
        #ff843f 49.48%,
        #a2f9e4 73.96%,
        #05feb1 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
    color: transparent;
    text-transform: none;

    background-size: 300%;
    background-position: -100%;

    &.gradient-text--animated {
        animation: animatedText 5s infinite alternate-reverse;
    }
}

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
